import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { u as useTablistContext } from './TablistContext-Bpw2P1bl.js';
import { s as scrollIntoBounds } from '../LocalModules/storm-ui-utils/dist/esm/scrollIntoBounds/scrollIntoBounds-Dhl2O567-Dhl2O567.js';
import { g as getFocusableElements } from '../LocalModules/storm-ui-utils/dist/esm/focusableElements/getFocusableElements-BjFtn5aB-BjFtn5aB.js';
import { K as KEYBOARD_KEYNAMES } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-CVa_vjg3-CVa_vjg3.js';

const NavWrapper = /*#__PURE__*/styled.nav.withConfig({
  componentId: "sc-storm-ui-40025937__sc-j2apjc-0"
})(["display:flex;", ""], isMobile(css(["overflow-x:scroll;::-webkit-scrollbar{display:none;}scrollbar-width:none;padding-inline-end:", ";"], ({
  theme
}) => theme.tabbedNavigation.scrollIndicatorWidth)));
const StyledUl = /*#__PURE__*/styled.ul.withConfig({
  componentId: "sc-storm-ui-40025937__sc-j2apjc-1"
})(["display:flex;flex-wrap:wrap;margin:0;padding:0;column-gap:", ";", ""], ({
  $size,
  theme
}) => $size === 'small' ? theme.controls.paddingInline.xxlarge.default : theme.controls.paddingInline.xxxlarge.default, isMobile(css(["flex-wrap:nowrap;overflow:visible;column-gap:", ";"], ({
  $size,
  theme
}) => $size === 'small' ? theme.controls.paddingInline.xxlarge.mobile : theme.controls.paddingInline.xxxlarge.mobile)));
const getOnKeyDown = tabGroupRef => event => {
  const {
    key
  } = event;
  if (tabGroupRef.current) {
    const focusableEls = getFocusableElements(tabGroupRef.current);
    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];

    // When "Left Arrow" or "Right Arrow" is pressed, move focus to the left or right tab
    if (key === KEYBOARD_KEYNAMES.ARROW_RIGHT || key === KEYBOARD_KEYNAMES.ARROW_LEFT || key === KEYBOARD_KEYNAMES.HOME || key === KEYBOARD_KEYNAMES.END) {
      const currentIndex = focusableEls.indexOf(document.activeElement);
      let newFocusIndex = 0;

      // When "Right Arrow" is pressed, focus on the tab to the right
      if (key === KEYBOARD_KEYNAMES.ARROW_RIGHT) {
        newFocusIndex = currentIndex + 1;
        if (document.activeElement === lastFocusableEl) {
          newFocusIndex = 0;
        }
      }

      // When "Left Arrow" is pressed, focus on the tab to the left
      if (key === KEYBOARD_KEYNAMES.ARROW_LEFT) {
        newFocusIndex = currentIndex - 1;
        if (document.activeElement === firstFocusableEl) {
          newFocusIndex = focusableEls.length - 1;
        }
      }

      // When "End" is pressed, focus on the last tab in the tab group
      if (key === KEYBOARD_KEYNAMES.END) {
        newFocusIndex = focusableEls.length - 1;
      }

      // When "Home" is pressed, focus on the first tab in the tab group
      if (key === KEYBOARD_KEYNAMES.HOME) {
        newFocusIndex = 0;
      }
      focusableEls[newFocusIndex].focus();
      event.preventDefault();
    }
  }
};
const Nav = ({
  children
}) => {
  const {
    isTablist,
    size
  } = useTablistContext();
  const navRef = useRef(null);
  const tabGroupRef = useRef(null);
  useEffect(() => {
    if (navRef.current) {
      var _navRef$current;
      scrollIntoBounds(navRef.current, (_navRef$current = navRef.current) === null || _navRef$current === void 0 ? void 0 : _navRef$current.querySelector('[aria-selected=true]'));
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(NavWrapper, {
    ref: navRef
  }, /*#__PURE__*/React__default.createElement(StyledUl, _extends({
    ref: tabGroupRef,
    $size: size
  }, isTablist ? {
    role: 'tablist',
    onKeyDown: getOnKeyDown(tabGroupRef)
  } : {}), children));
};

export { Nav as N };
//# sourceMappingURL=Nav-C7yH0lXU.js.map
